module.exports = __webpack_public_path__ + "img/game.eb58d2ae.png";